import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { useAuth } from '../contexts/AuthContext';
import { showSuccessToast } from '../utils/toastHelper';
import { usePermissions } from '../contexts/PermissionsContext';

const Header = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation('header');
  const { user } = useAuth();
  const { permissions, permittedRoutes } = usePermissions();
  const [openLogout, setOpenLogout] = useState(false);
  const [openLangChange, setOpenLangChange] = useState(false);
  const { logout } = useAuth();

  const handleAccountClick = () => {
    setOpenLogout(!openLogout);
  };
  const handleLangeChangeClick = () => {
    setOpenLangChange(!openLangChange);
  };

  const handleOutsideClick = (e) => {
    if (!e.target.closest('.account')) {
      setOpenLogout(false);
    }
    if (!e.target.closest('.green')) {
      setOpenLangChange(false);
    }
  };
  const handleLogoutClick = async (e) => {
    e.stopPropagation();
    console.log('Logout clicked');
    await logout();
    setOpenLogout(false);
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  return (
    <nav className={`navbar navbar-expand-lg bg-body-tertiary fixed`}>
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img src="images/logo-single.svg" alt="Logo" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          {/* navbar */}
          <ul className="navbar-nav">
            {/* Orders */}
            {(permittedRoutes.includes('/') ||
              permittedRoutes.includes('/orders-catering')) && (
              <li
                className={`nav-item ${['/', '/orders-catering'].includes(pathname) ? 'active' : ''}`}
              >
                <div className="dropdown">
                  <Link
                    className="btn  dropdown-toggle "
                    to="#"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src="images/order.svg" alt="" />
                    {t('ORDERS')}
                  </Link>
                  <ul className="dropdown-menu">
                    {permittedRoutes.includes('/') && (
                      <li className={`${pathname === '/' ? 'active' : ''}`}>
                        <Link className="dropdown-item" to="/">
                          {t('FBZ')}
                        </Link>
                      </li>
                    )}
                    {permittedRoutes.includes('/orders-catering') && (
                      <li
                        className={`${pathname === '/orders-catering' ? 'active' : ''}`}
                      >
                        <Link className="dropdown-item" to="orders-catering">
                          {t('CATERING')}
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
            )}
            {/* Picking List */}
            {(permittedRoutes.includes('/fbz-picking-list') ||
              permittedRoutes.includes('/catering-picking-list')) && (
              <li
                className={`nav-item ${['/fbz-picking-list', '/catering-picking-list'].includes(pathname) ? 'active' : ''}
                 `}
              >
                <div className="dropdown">
                  <Link
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src="images/picking-list.svg" alt="" />
                    {t('PICKINGLISTS')}
                  </Link>

                  <ul className="dropdown-menu">
                    {permittedRoutes.includes('/fbz-picking-list') && (
                      <li
                        className={`${['/fbz-picking-list'].includes(pathname) ? 'active' : ''}`}
                      >
                        <Link className="dropdown-item" to="/fbz-picking-list">
                          {t('FBZ')}
                        </Link>
                      </li>
                    )}
                    {permittedRoutes.includes('/catering-picking-list') && (
                      <li
                        className={`${['/catering-picking-list'].includes(pathname) ? 'active' : ''}`}
                      >
                        <Link
                          className="dropdown-item"
                          to="/catering-picking-list"
                        >
                          {t('CATERING')}
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
            )}
            {/* Logistics */}
            {permittedRoutes.includes('/logistics') && (
              <li
                className={`nav-item ${pathname === '/logistics' ? 'active' : ''}`}
              >
                <div className="dropdown">
                  <Link to="logistics" className="btn " type="button">
                    <img src="images/logistics.svg" alt="" />
                    {t('LOGISTICS')}
                  </Link>
                </div>
              </li>
            )}
            {/* LOB Products */}
            {permittedRoutes.includes('/lob-products') && (
              <li
                className={`nav-item ${pathname === '/lob-products' ? 'active' : ''}`}
              >
                <div className="dropdown">
                  <Link to="lob-products" className="btn " type="button">
                    <img src="images/product.svg" alt="" />
                    {t('LOBPRODUCTS')}
                  </Link>
                </div>
              </li>
            )}
            {/* FBZ Section */}
            {(permittedRoutes.includes('/fbz-orders') ||
              permittedRoutes.includes('/fbz-customers') ||
              permittedRoutes.includes('/fbz-customers-group') ||
              permittedRoutes.includes('/fbz-products') ||
              permittedRoutes.includes('/fbz-inventory')) && (
              <li
                className={`nav-item ${
                  [
                    '/fbz-orders',
                    '/fbz-customers',
                    '/fbz-customers-group',
                    '/fbz-inventory',
                    '/fbz-products',
                    '/fbz-sales-summary',
                    '/fbz-sales-quantity',
                    '/fbz-sales-analysis',
                  ].includes(pathname)
                    ? 'active'
                    : ''
                }
                   `}
              >
                <div className="dropdown">
                  <Link
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src="images/FBZ.svg" alt="" />
                    {t('FBZ')}
                  </Link>

                  <ul className="dropdown-menu">
                    {permittedRoutes.includes('/fbz-orders') && (
                      <li
                        className={`nav-item ${pathname === '/fbz-orders' ? 'active' : ''}`}
                      >
                        <Link to="/fbz-orders" className="dropdown-item">
                          {t('ORDERS')}
                        </Link>
                      </li>
                    )}
                    {permittedRoutes.includes('/fbz-products') && (
                      <li
                        className={`nav-item ${pathname === '/fbz-products' ? 'active' : ''}`}
                      >
                        <Link to="/fbz-products" className="dropdown-item">
                          {t('PRODUCTS')}
                        </Link>
                      </li>
                    )}
                    {(permittedRoutes.includes('/fbz-customers') ||
                      permittedRoutes.includes('/fbz-customers-group')) && (
                      <li
                        className={`nav-item hover-list ${
                          ['/fbz-customers-group', '/fbz-customers'].includes(
                            pathname
                          )
                            ? 'active'
                            : ''
                        }
                         `}
                      >
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={(e) => {
                            e.preventDefault(); // Prevents navigation
                            e.stopPropagation(); // Stops dropdown from closing
                          }}
                        >
                          {t('CUSTOMER')}{' '}
                          <img
                            src="images/expand-black.png"
                            alt=""
                            className="black"
                          />
                        </Link>
                        {/* Customers sub menu */}
                        <ul className="sheet-list-data">
                          {permittedRoutes.includes('/fbz-customers') && (
                            <li
                              className={`nav-item ${pathname === '/fbz-customers' ? 'active' : ''}`}
                            >
                              <Link
                                className="dropdown-item"
                                to="/fbz-customers"
                              >
                                {t('CUSTOMER')}
                              </Link>
                            </li>
                          )}
                          {permittedRoutes.includes('/fbz-customers-group') && (
                            <li
                              className={`nav-item ${pathname === '/fbz-customers-group' ? 'active' : ''}`}
                            >
                              <Link
                                className="dropdown-item"
                                to="/fbz-customers-group"
                              >
                                {t('CUSTOMERGROUP')}
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                    )}
                    {permittedRoutes.includes('/fbz-inventory') && (
                      <li
                        className={`nav-item ${pathname === '/fbz-inventory' ? 'active' : ''}`}
                      >
                        <Link className="dropdown-item" to="/fbz-inventory">
                          {t('INVENTORY')}
                        </Link>
                      </li>
                    )}
                    {/* {permittedRoutes.includes('/fbz-report') && (
                        <li
                          className={`nav-item ${pathname === '/fbz-report' ? 'active' : ''}`}
                        >
                          <Link className="dropdown-item" to="/fbz-report">
                            {t('REPORT')}
                          </Link>
                        </li>
                      )} */}

                    {(permittedRoutes.includes('/fbz-sales-summary') ||
                      permittedRoutes.includes('/fbz-sales-quantity') ||
                      permittedRoutes.includes('/fbz-sales-analysis')) && (
                      <li
                        className={`nav-item hover-list ${
                          pathname === '/fbz-sales-summary' ||
                          pathname === '/fbz-sales-quantity' ||
                          pathname === '/fbz-sales-analysis'
                            ? 'active'
                            : ''
                        }`}
                      >
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={(e) => {
                            e.preventDefault(); // Prevents navigation
                            e.stopPropagation(); // Stops dropdown from closing
                          }}
                        >
                          {t('REPORT')}
                          <img
                            src="images/expand-black.png"
                            alt=""
                            className="black"
                          />
                        </Link>

                        <ul className="sheet-list-data">
                          {permittedRoutes.includes('/fbz-sales-summary') && (
                            <li
                              className={`nav-item ${pathname === '/fbz-sales-summary' ? 'active' : ''}`}
                            >
                              <Link
                                className="dropdown-item"
                                to="/fbz-sales-summary"
                              >
                                {t('SALESSUMMARY')}
                              </Link>
                            </li>
                          )}
                          {permittedRoutes.includes('/fbz-sales-quantity') && (
                            <li
                              className={`nav-item ${pathname === '/fbz-sales-quantity' ? 'active' : ''}`}
                            >
                              <Link
                                className="dropdown-item"
                                to="/fbz-sales-quantity"
                              >
                                {t('SALESQUANTITY')}
                              </Link>
                            </li>
                          )}
                          {permittedRoutes.includes('/fbz-sales-analysis') && (
                            <li
                              className={`nav-item ${pathname === '/fbz-sales-analysis' ? 'active' : ''}`}
                            >
                              <Link
                                className="dropdown-item"
                                to="/fbz-sales-analysis"
                              >
                                {t('SALESANALYSIS')}
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                    )}
                  </ul>
                </div>
              </li>
            )}
            {/* Catering */}
            {(permittedRoutes.includes('/catering-orders') ||
              // permittedRoutes.includes('/catering-picking-list') ||
              permittedRoutes.includes('/catering-customers-group') ||
              permittedRoutes.includes('/catering-customers')) && (
              <li
                className={`nav-item ${
                  [
                    '/catering-orders',
                    // '/catering-picking-lists',
                    '/catering-customers',
                    '/catering-customers-group',
                    // "/catering-inventory",
                  ].includes(pathname)
                    ? 'active'
                    : ''
                }
                   `}
              >
                <div className="dropdown">
                  <Link
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src="images/catering.svg" alt="" />
                    {t('CATERING')}
                  </Link>

                  <ul className="dropdown-menu">
                    {permittedRoutes.includes('/catering-orders') && (
                      <li
                        className={`nav-item ${pathname === '/catering-orders' ? 'active' : ''}`}
                      >
                        <Link className="dropdown-item" to="/catering-orders">
                          {t('ORDERS')}
                        </Link>
                      </li>
                    )}
                    {/* {permittedRoutes.includes('/catering-picking-lists') && (
                      <li
                        className={`nav-item ${pathname === '/catering-picking-lists' ? 'active' : ''}`}
                      >
                        <Link
                          className="dropdown-item"
                          to="/catering-picking-lists"
                        >
                          {t('PICKINGLISTS')}
                        </Link>
                      </li>
                    )} */}
                    {(permittedRoutes.includes('/catering-customers') ||
                      permittedRoutes.includes(
                        '/catering-customers-group'
                      )) && (
                      <li
                        className={`nav-item hover-list ${
                          [
                            '/catering-customers-group',
                            '/catering-customers',
                          ].includes(pathname)
                            ? 'active'
                            : ''
                        }
                           `}
                      >
                        <Link
                          className="dropdown-item"
                          // to="/catering-customers"
                          to="#"
                          onClick={(e) => {
                            e.preventDefault(); // Prevents navigation
                            e.stopPropagation(); // Stops dropdown from closing
                          }}
                        >
                          {t('CUSTOMER')}{' '}
                          <img
                            src="images/expand-black.png"
                            alt=""
                            className="black"
                          />
                        </Link>
                        {/* Customers sub menu */}

                        <ul className="sheet-list-data">
                          {permittedRoutes.includes('/catering-customers') && (
                            <li
                              className={`nav-item ${pathname === '/catering-customers' ? 'active' : ''}`}
                            >
                              <Link
                                className="dropdown-item"
                                to="/catering-customers"
                              >
                                {t('CUSTOMER')}
                              </Link>
                            </li>
                          )}
                          {permittedRoutes.includes(
                            '/catering-customers-group'
                          ) && (
                            <li
                              className={`nav-item ${pathname === '/catering-customers-group' ? 'active' : ''}`}
                            >
                              <Link
                                className="dropdown-item"
                                to="/catering-customers-group"
                              >
                                {t('CUSTOMERGROUP')}
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                    )}
                    {/* {permittedRoutes.includes("/catering-inventory") && (
                      <li
                        className={`nav-item ${pathname === "/catering-inventory" ? "active" : ""}`}
                      >
                        <Link
                          className="dropdown-item"
                          to="/catering-inventory"
                        >
                          {t("INVENTORY")}
                        </Link>
                      </li>
                    )} */}
                  </ul>
                </div>
              </li>
            )}

            {/* Master Data */}
            {permittedRoutes.includes('/master-data') && (
              <li
                className={`nav-item ${pathname === '/master-data' ? 'active' : ''}`}
              >
                <div className="dropdown">
                  <Link to="master-data" className="btn " type="button">
                    <img src="images/master-data.svg" alt="" />
                    {t('MASTERDATA')}
                  </Link>
                </div>
              </li>
            )}

            {/* Permissions */}
            {permittedRoutes.includes('/permissions') && (
              <li
                className={`nav-item ${pathname === '/permissions' ? 'active' : ''}`}
              >
                <div className="dropdown">
                  <Link className="btn" to="permissions" type="button">
                    <img src="images/permissions.svg" alt="" />
                    {t('PERMISSIONS')}
                  </Link>
                </div>
              </li>
            )}
          </ul>

          <ul className="right position-relative">
            <li className="green">
              <LanguageSwitcher
                handleLangeChangeClick={handleLangeChangeClick}
                openLangChange={openLangChange}
              />
            </li>
            {/* <li className="orange">
              <Link to="notifications" className="bell">
                <img src="images/bell.svg" alt="" />
              </Link>
            </li> */}
            <li className="green">
              <Link to="setting" className="button setting">
                <img src="images/setting.svg" alt="" />
              </Link>
            </li>
            <li className="account" onClick={handleAccountClick}>
              <Link>
                <img
                  src={user?.profile_picture || 'images/empty-user.png'}
                  alt=""
                />
              </Link>
              {openLogout && (
                <div className="logout" onClick={handleLogoutClick}>
                  <p>
                    <img src="images/shutdown.png" alt="" />
                    {t('LOGOUT')}
                  </p>
                </div>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
